import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../shared/auth/auth.service';

/**
 * Component to display specific error messages to the user, such as 404 or
 * access denied errors.
 */
@Component({
    selector: 'flo-error-page',
    templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit {
    public errorMessage: string;

    /**
     * Constructor
     */
    constructor(
                private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private title: Title,
    ) {
    }

    public ngOnInit(): void {
        const errorType: string = this.activatedRoute.snapshot.params['error-id'];

        switch (errorType) {
            case 'access-denied':
                this.errorMessage = this.authService.getAccessDeniedMsg();
                this.title.setTitle(this.errorMessage);
                break;
            case 'access-denied-event':
                this.errorMessage =
                `${this.authService.getAccessDeniedMsg()}: You do not have access to the requested event`;
                this.title.setTitle(this.errorMessage);
                break;
            case 'access-denied-event-dual':
                this.errorMessage =
                `${this.authService.getAccessDeniedMsg()}: Dual events must be managed through the team calendar`;
                this.title.setTitle(this.errorMessage);
                break;
            default:
                this.errorMessage = 'Page not found';
                this.title.setTitle(this.errorMessage);
        }
    }
}
